import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workflow-type',
  templateUrl: './workflow-type.component.html',
  styleUrls: ['./workflow-type.component.css']
})
export class WorkflowTypeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
